import { getAuditUnitWarnings } from "../../../utilities/auditUtilities"
import { lastSix } from "../../../utilities/unitUtilities"
import InfoItem from "../../common/InfoItem"
import UploadBos from "../../Dealer/UnitPage/UploadBos"
import AuditUnitWarnings from "./AuditUnitWarnings"
import AchInitiatedAlert from "./AchInitiatedAlert"
import MarkSoldUnsold from "../../Dealer/UnitPage/MarkSoldUnsold"
import useStore from "../../../store"

export default function AuditUnitDetails({ auditUnit }) {
  const unit = useStore((state) => state.unit)
  const warnings = getAuditUnitWarnings(auditUnit)
  const unitMatchesAudit = unit && auditUnit && String(unit.id) === String(auditUnit.attributes['unit-id'])

  return (
    <div className="flex flex-col items-start w-full px-2">
      <p className="text-lg text-grey-300">{auditUnit?.attributes?.year} {auditUnit?.attributes?.make}</p>
      <p className= 'text-4xl text-grey-100'>{auditUnit?.attributes?.model}</p>
      <AuditUnitWarnings warnings={warnings} />
      <AchInitiatedAlert auditUnit={auditUnit} />
      <div className="w-full grid grid-cols-2 lg:grid-cols-3">
        <InfoItem title="Last Six">
          {auditUnit && lastSix(auditUnit?.attributes?.vin)}
        </InfoItem>
        <InfoItem title="Days Floored">
          {auditUnit?.attributes["days-floored"]}
        </InfoItem>
        {unitMatchesAudit &&
          <>
            <div className="w-full col-span-2">
              {unit.attributes.sold && <UploadBos unit={unit} />}
            </div>
            <div className="w-full col-span-2">
              <MarkSoldUnsold unit={unit} />
            </div>
          </>
        }
      </div>
    </div>
  )
}